import 'css-chunksrc/client/scenes/workloads/calendar/months/month/styles.scss';export default {
  "month": "_month_8z4kc_1",
  "monthName": "_monthName_8z4kc_16",
  "year": "_year_8z4kc_31",
  "weeks": "_weeks_8z4kc_35",
  "cutOffWeek": "_cutOffWeek_8z4kc_40",
  "week": "_week_8z4kc_35",
  "weekNbr": "_weekNbr_8z4kc_57",
  "even": "_even_8z4kc_61",
  "odd": "_odd_8z4kc_65"
};